<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="`${$t('menu.OrderNumber')}/${$t('menu.ContractNumber')}`"
          v-model="formInline.title"></el-input>
      </el-form-item>
      <!-- <el-form-item >
          <el-select v-model="formInline.staue" placeholder="订单类型" clearable>
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item,index) in staue" :key="index" :label="item.name" :value="item.id"></el-option>
         
          </el-select>
        </el-form-item> -->
        
        <el-form-item>
        <el-select v-model="orderType" :placeholder="$t('menu.Paymentmethod')" clearable>
          <!-- <el-option label="全部" value=""></el-option> -->
          <el-option v-if="inle == 'zh'" v-for="(item, index) in odtype" :key="index" :label="item.dictLabel"
            :value="item.dictValue"></el-option>
          <el-option v-if="inle !== 'zh'" v-for="(item, index) in odtype" :key="index" :label="item.dictLabelEn"
            :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.type" :placeholder="$t('menu.Paymentmethod')" clearable>
          <!-- <el-option label="全部" value=""></el-option> -->
          <el-option v-if="inle == 'zh'" v-for="(item, index) in jsfs" :key="index" :label="item.dictLabel"
            :value="item.dictValue"></el-option>
          <el-option v-if="inle !== 'zh'" v-for="(item, index) in jsfs" :key="index" :label="item.dictLabelEn"
            :value="item.dictValue"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item >
          <el-col :span="11">
      <el-date-picker type="date" placeholder="开始时间" v-model="formInline.data1" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">-</el-col>
    <el-col :span="11">
      <el-date-picker placeholder="结束时间" v-model="formInline.data2" style="width: 100%;"></el-date-picker>
    </el-col>
        </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        <!-- <el-button>重置</el-button> -->
      </el-form-item>
    </el-form>
    <div class="bonntbot">
      <el-tabs v-model="action" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in staue" :key="index"
          :label="item.num > 0 ? item.name + '(' + item.num + ')' : item.name" :name="item.id"></el-tab-pane>


      </el-tabs>
      <div class="bonntbota">
        <!-- <el-button type="text" @click="downOrder">{{ $t('menu.ExportOrder') }}</el-button>
        <el-button type="text" @click="downOrderDetails">{{ $t('menu.ExportDetails') }}</el-button> -->
      </div>

    </div>
    <el-table  empty-text=" " :data="mation" style="width: 100%" border highlight-current-row @selection-change="handleSelectionChange">
      <!-- <el-table-column type="selection" width="70">
      </el-table-column> -->
     
      <el-table-column prop="pc" :label="$t('menu.OrderNumber')" width="200">
        <template slot-scope="scope">
        <div>  {{ scope.row.po.orderNumber }}</div>
        <div v-if=" scope.row.po.orderType==1">
          {{ $t('menu.erlunpej') }}
        </div> 
         <div v-if=" scope.row.po.orderType==2">
          {{ $t('menu.erlunzhengc') }}
        </div>
         <div v-if=" scope.row.po.orderType==3">
          {{ $t('menu.silunpej') }}
        </div>
         <div v-if=" scope.row.po.orderType==4">
          {{ $t('menu.silunzhengc') }}
        </div>
        <div v-if=" scope.row.po.orderType==9000">
          {{ $t('menu.zhoubianq') }}
        </div>
        </template>
      </el-table-column>
       <el-table-column prop="cjh" :label="$t('menu.zcmxlsh') " width="90">
        <template slot-scope="scope">
          <div>
            <div>{{ pdlsh(scope.row.po.dealerId) }}</div>
            <div>{{ pdlsha(scope.row.po.dealerId) }}</div>
          </div>
          <!-- {{ scope.row.po.dealerName }} -->
        </template>
      </el-table-column>
      <!-- <el-table-column prop="orderNumber" :label="$t('menu.ContractNumber')">
        <template slot-scope="scope">
          {{ scope.row.po.saleNumber }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="cjh" :label="$t('menu.Currency')" width="90">
        <template slot-scope="scope">
          {{ scope.row.po.currencyType }}
        </template>
      </el-table-column> -->
      <el-table-column prop="vin" :label="$t('menu.PurchaseAmount')" >
        <template slot-scope="scope">
          {{ scope.row.po.orderAmount }}  {{ ctype(scope.row.po.accTypeId) }}
        </template>
      </el-table-column>
      <el-table-column prop="discountAmount" :label="$t('menu.yueikou')" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.po.discountAmount!==null">
            {{ scope.row.po.discountAmount }}
          </div>
          <div v-else>
           0
          </div>
        </template>
      </el-table-column>
       <el-table-column prop="vin" :label="$t('menu.zhuanggjine')" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.po.discountAmount!==null">
 
            {{ ccbaopl(scope.row.po.orderAmount-scope.row.po.discountAmount) }}
        
         
          
          </div>
          <div v-else>
          {{ scope.row.po.orderAmount }}
          </div>
          
        </template>
      </el-table-column>
       <el-table-column prop="settleAmount" :label="$t('menu.yijiesuanjine')" >
        <template slot-scope="scope">
          {{ scope.row.po.settleAmount? scope.row.po.settleAmount:0 }}   {{ ctype(scope.row.po.accTypeId) }}
        </template>
      </el-table-column>
        <el-table-column prop="settleAmount" :label="$t('menu.daijinsuanjin')" >
        <template slot-scope="scope">
          {{ ccbaopl(scope.row.po.orderAmount-scope.row.po.discountAmount)-scope.row.po.settleAmount}}   {{ ctype(scope.row.po.accTypeId) }}
        </template>
      </el-table-column>
      <el-table-column prop="xsd" :label="$t('menu.DeliveryProgress')">
        <template slot-scope="scope">
          <div>
            {{ $t('menu.Quantity') }}： {{ scope.row.po.shippedQuantity }} /
            {{ scope.row.po.quantity }}
          </div>
          <div>
            {{ $t('menu.Kind') }}： <span>{{
              scope.row.po.shippedTypeQuantity
            }}</span> /{{
                scope.row.po.typeQuantity
              }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="zt" :label="$t('menu.Paymentmethod')">
        <template slot-scope="scope">
          {{ jstype(scope.row.po.paymentMethod) }}
        </template>
      </el-table-column>

      <el-table-column prop="rk" :label="$t('menu.State')" width="80">
        <template slot-scope="scope">
          {{ formatStatus(scope.row.po.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="xs" :label="$t('menu.OrderTime')" width="170">
        <template slot-scope="scope">
          {{ scope.row.po.orderTime.slice(0, 10) }}{{ ' '
          }}{{ scope.row.po.orderTime.slice(11, 19) }}
        </template>
      </el-table-column>
      <el-table-column >
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.Operation') }}</div>
        </template>
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleEdit(2, scope.row)">{{ $t('menu.Details') }}</el-button>
          <el-button type="text" size="mini" v-if="typin==1&&scope.row.po.orderAmount!==scope.row.po.settleAmount&&scope.row.po.paymentMethod!=='co'" @click="jspop(scope.row)">{{ $t('menu.zhejsijiesuan') }}</el-button>
           <!-- <el-button type="text" size="mini" v-if="scope.row.po.status!==1&& scope.row.po.status!==-1&&scope.row.po.status!==-2" @click="erpzd( scope.row)">{{
            $t('menu.erpzd') }}</el-button> -->
             <el-button type="text" size="mini" v-if="typin==1&&scope.row.po.orderType==1||scope.row.po.orderType==3" @click="jspopa(scope.row)">{{ $t('menu.dayinbiaoq') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>
    </div>
 <el-dialog title="向erp制单" :visible.sync="dialogVisiblea" v-if="dialogVisiblea" width="700px" :before-close="handleClose">
      <div class="ccca" style=" margin: 0 auto">
       <div style="width: 100%;display: flex;    align-items: center;">
        <div style="width: 40%;">
          商户简称：{{ erpform.po.dealerName}}
        </div>
        <div  style="width: 40%;">
          erp商户名称：{{ erpform.po.erpName}}
        </div>
       </div>
      <div style="width: 100%;display: flex;margin: 10px 0;    align-items: center;">
        <div  style="width: 30%;">
          配件总数：{{ erpform.po.quantity}}
        </div>
        <div  style="width: 30%;">
          订单总额：{{ erpform.po.orderAmount}}{{  erpform.po.currencyType?erpform.po.currencyType:'' }}
        </div>
         <div  style="width: 38%;display: flex;    align-items: center;">
         <div style="width: 60%;">期望发货日期：</div>
         <el-date-picker
      v-model="erpform.po.shippingDate"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
        </div>
       </div>
       <div>备注：</div>
       <div style="margin-top: 10px;">
             <el-input
       type="textarea"
       :rows="2"
       placeholder="请输入内容"
       v-model="erpform.po.remarks">
       </el-input>
       </div>
        <div style=" margin: 30px auto" class="er">
          <el-button  type="primary" @click="updata"
            class="er">{{ $t('menu.Confirm') }}</el-button>
       

        </div>
      </div>
    </el-dialog>
     <el-dialog :title="$t('menu.zhejsijiesuan')" :visible.sync="dialogjs" v-if="dialogjs" width="300px" :before-close="handleClose">
      <div class="ccca" style=" margin: 0 auto">
       <div style="width: 100%;">
        <div><span style="color: red;">*</span> {{ $t('menu.zheshijiesuanjine') }} ( {{bz  }})</div>
       <div style="margin-top: 10px;">
             <el-input
      
       v-model="jsdata.settleAmount">
       </el-input>
       </div>
        <div>{{ $t('menu.Remarks') }}</div>
       <div style="margin-top: 10px;">
             <el-input
       type="textarea"
       :rows="2"
       
       v-model="jsdata.remarks">
       </el-input>
       </div>
    
      
       </div>
        <div style=" margin: 30px auto" class="er">
          <el-button  type="primary" @click="jsup"
            class="er">{{ $t('menu.Confirm') }}</el-button>
       

        </div>
      </div>
    </el-dialog>
      <el-dialog title="打印" :visible.sync="dialogdy" v-if="dialogdy" width="600px" :before-close="handleClose">
                
      
        <el-table
    border
     ref="multipleTable"
    :data="mationac"
    tooltip-effect="dark"
    style="width: 100%"
    @selection-change="handleSelectionChangea">
      <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      prop="partNameEn"
      label="配件名称"
     >
    </el-table-column>
    <el-table-column
      prop="partNumber"
      label="配件编号"
    >
    </el-table-column>
    <el-table-column
      prop="motorName"
      label="所属车型">
      
      <template slot-scope="scope">
          {{inle=='zh'? scope.row.motorName:scope.row.motorNameEn}}
        </template>
    </el-table-column>
      <el-table-column
      prop="quantity"
      label="代发货数量">  </el-table-column>
      <el-table-column
      prop="printQuantity"
      label="打印数量">
      <template slot-scope="scope">
        
          <el-input v-model="scope.row.printQuantity"  ></el-input>
        </template>
    </el-table-column>
      
  </el-table>
        <div style=" margin: 30px auto" class="er">
          <el-button  type="primary" @click="queddayin"
            class="er">{{ $t('menu.Confirm') }}</el-button>
       

        </div>
     
    </el-dialog>
    <div></div>
  </div>
</template>

<script>
import { pomyPosa, querytype,listAccType, pageSumMyPoA,partLabelOfDealer,orderSearch,retailerlist,poAddSettleAmount, exportMyPo, exportMyPoDetails,submitMyErpOrder } from '../../api/api'

export default {
  data () {
    return {
      action: '99',
      staue: [
        {
          name: this.$t('menu.All'),
          num: 0,
          id: '99',
        },
        {
          name: this.$t('menu.PendingReview'),
          num: 0,
          id: '1',
        },
        {
          name: this.$t('menu.daizhid'),
          num: 0,
          id: '5',
        },
        {
          name: this.$t('menu.PendingShipment'),
          num: 0,
          id: '2',
        },
        {
          name: this.$t('menu.UnderDelivery'),
          num: 0,
          id: '3',
        },
        {
          name: this.$t('menu.Completed'),
          num: 0,
          id: '4',
        },
        // {
        //   name: '待支付',
        //   num: 2,
        //   id: '0',
        // },
        {
          name: this.$t('menu.Rejected'),
          num: 0,
          id: '-2',
        },
        {
          name: this.$t('menu.Cancelled'),
          num: 0,
          id: '-1',
        },
      ],
      jsfs: [],
      currentPage3: 1,
      pageSize: 10,
      totale: 3,
      erpform:{},
         dialogVisiblea:false,
         dialogjs:false,
         dialogdy:false,
         bz:'',
      orderType:'',
      mation: [], //列表
      formInline: {
        title: '',
        startTime: '',
        endTime: '',
        contact: '',
        category: '',
        type: '',
        staue: '',
        data1: '',
        data2: '',
        
      },
      formInlineac:{
        title:''
      },
      jsdata:{
        settleAmount:'',
        remarks:'',
        id:''

      },
      inle: 'zh',
      odtype:'',
      acclist:[],
      typin:0,
      lslis:[],
      mationac:[ ],
      multipleSelection:[],
      matinfo:{},
    }
  },
  created () {
    let a = sessionStorage.getItem('i18n')
   this.typin=sessionStorage.getItem('platform')
    this.inle = a
    this.querytyp()
    this.action = '99'
    this.biao()
    this.accc()
    this.lsslist()
  },
  methods: {
    changae (e) {
      // console.log(1);
      
      this.$forceUpdate()
    },
     pdlsh(e){
      let a =this.lslis
      let c= ''
      a.forEach(z=>{
          if(z.id==e){
            c=z.dealerName
          }
      })
      return c 
    },
      async lsslist(){
      
        let param = new URLSearchParams()
      const { data: res } = await retailerlist(param, 1,500)
      // console.log(res.rows);
    this.lslis=res.rows
      
    },

     pdlsha(e){
      let a =this.lslis
      let c= ''
      a.forEach(z=>{
          if(z.id==e){
            c=z.dealerNameFull
          }
      })
      return c 
    },
      ccbaopl(e){
    let a = 0
    if(e>0){
      a=e.toFixed(2)
    }
 
    
    return a
   },
     erpzd(e){
      // console.log(e);
      
      this.erpform=e
      this.dialogVisiblea=true
    },
    async  queddayin(){
      let a =[]
      this.multipleSelection.forEach(e=>{
        let b ={
          mcSeriesModels:e.motorId,
          partId:e.partId,
          partName:e.partNameEn,
          partNumber:e.partNumber,
          poOrderNum:this.matinfo.po.orderNumber,
          poStoreId:this.matinfo.po.dealerId,
           poStoreName:this.matinfo.po.dealerName,
            printQuantity:e.printQuantity,
             shipQuantity:e.shipQuantity
        }
        a.push(b)
      })
      let param =a

      const { data: res } = await partLabelOfDealer(param)
      if(res.code=='500'){
 this.$message.error(res.msg)
      }else{
        this.$message.success(res.data.message)
        this.handleClose()
       this.biao()
      }
      
    },
   async updata(){

  let param = this.erpform
  param.po.shippingDate=param.po.shippingDate.slice(0, 10)+' 00:00:00'
      const { data: res } = await submitMyErpOrder(param)
      if(res.code=='500'){
 this.$message.error(res.msg)
      }else{
        this.$message.success('取消成功')
          this.handleClose()
       this.biao()
      }
      
  
    },
       async accc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
         

    },
    ctype(e){
      let a = ''
      this.acclist.forEach(z=>{
           if(z.id==e){
              a=z.currencyName
          }
      })
      return a
    },
    handleClose(){
      this.erpform={}
      this.jsdata={
        settleAmount:'',
        remarks:'',
        id:''

      },
      this.bz=''
      this.dialogVisiblea=false
      this.dialogjs=false
      this.dialogdy=false
    },
    downOrderDetails () {
      let obj = {
        status: this.action
      }
      exportMyPoDetails(obj).then(res => {
        // const link = document.createElement('a')
        // let blob = new Blob([res.data], { type: 'application/x-www-form-urlencoded' })
        // link.style.display = 'none'
        // link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', '我的采购订单明细.xlsx')
        // document.body.appendChild(link)
        // link.click() //触发下载
        // document.body.removeChild(link)

        // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '我的采购订单明细.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })
    },
    downOrder () {
      let obj = {
        status: this.action
      }
      exportMyPo(obj).then(res => {
        // const link = document.createElement('a')
        // let blob = new Blob([res.data], { type: 'application/x-www-form-urlencoded' })
        // link.style.display = 'none'
        // link.href = URL.createObjectURL(blob)
        // link.setAttribute('download', '我的采购订单.xlsx')
        // document.body.appendChild(link)
        // link.click() //触发下载
        // document.body.removeChild(link)
        // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
        const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '我的采购订单.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
      })
    },
    async biao () {
      let a = ''
      if (this.action == '99') {
        a = ''
      } else {
        a = this.action
      }
      console.log(123123,this.orderType);
      
      let param = new URLSearchParams()
      let status = a
      const { data: res } = await pomyPosa(
        param,
        this.currentPage3,
        this.pageSize,
        status,
        this.formInline.type,
        this.formInline.title,
        // this.formInline.data1,
        // this.formInline.data2,
        this.orderType,
        'SO'
      )

      this.mation = res.data.list
      this.totale = res.data.total
      this.numlist()
    },
   async jsup(){
        if(this.jsdata.settleAmount==''){
           this.$message.error('请填写结算金额')
           return false
        }
       let param = this.jsdata
      const { data: res } = await poAddSettleAmount(param)
      console.log(res);
      
      if(res.code==200){
        this.$message.success('结算成功')
        this.handleClose()
        this.biao()
      }
    },
    async numlist () {

      let param = {
        orderName:'SO'
      }
      const { data: res } = await pageSumMyPoA(param)
      let a = this.staue
      let b = 0
      let c = 0
      res.data.forEach(e => {
        a.forEach((z, i) => {
          if (e.status == z.id) {
            this.staue[i].num = e.sum
          } else {
            if (e.status == 5) {
          

              b = e.sum
            }
            if (e.status == 1) {
              // console.log(1);

              c = e.sum
            }
          }


        })


      })
      // this.staue[1].num = b + c
    },
     handleSelectionChangea(val) {
        this.multipleSelection = val;
      },
    handleSelectionChange () { },
    async querytyp () {
      let param = new URLSearchParams()
      const { data: res } = await querytype(param, 't_po_payment_method')
      this.jsfs = res.data
      this.jsfs.unshift({
        dictLabel: this.$t('menu.All'),
        dictValue: ' ',
        dictLabelEn: this.$t('menu.All'),
      })
      this.odtype=[
        {
          dictLabel: this.$t('menu.All'),
        dictValue: ' ',
        dictLabelEn: this.$t('menu.All'),
        },
        { 
          dictLabel: this.$t('menu.erlunpejdd'),
        dictValue: '1',
        dictLabelEn: this.$t('menu.erlunpejdd'),
        },
        {
          dictLabel: this.$t('menu.erlunzhengcdd'),
        dictValue: '2',
        dictLabelEn: this.$t('menu.erlunzhengcdd'),
        },
         { 
          dictLabel: this.$t('menu.silunpejdd'),
        dictValue: '3',
        dictLabelEn: this.$t('menu.silunpejdd'),
        },
        {
          dictLabel: this.$t('menu.silunzhengcdd'),
        dictValue: '4',
        dictLabelEn: this.$t('menu.silunzhengcdd'),
        },
         {
          dictLabel: this.$t('menu.zhoubianq'),
        dictValue: '9000',
        dictLabelEn: this.$t('menu.zhoubianq'),
        },
      ]
    },
    handleClick (tab, event) {
      this.action = tab.name
      this.biao()
      // console.log(tab, event)
    },
    jspop(e){
      this.jsdata.id=e.po.id
     this.bz= this.ctype(e.po.accTypeId)
      this.dialogjs=true
    },
   async jspopa(e){
      // this.$message.warning(this.$t('menu.zanwuquanx'))
     
      this.dialogdy=true
       
      let param = new URLSearchParams();
      // let orderNumber =e.po.orderNumber
       let  orderid= e.po.id
      const { data: res } = await orderSearch(param, orderid);
      // console.log(res)
    
      this.mationac=[]
      this.matinfo=res.data
    if(res.data?.poParts){
      res.data.poParts.forEach(z=>{
      
       this.$set(z, 'printQuantity', '1')
        z.shipQuantity=z.quantity- z.shippedQuantity
      })
        this.mationac=res.data.poParts
    }
    
  
    
    },
    
    //表单点击
    handleEdit (index, row) {
      let a = sessionStorage.getItem('name')
      let b = sessionStorage.getItem('namef')
      sessionStorage.setItem('namefac1',a )
      sessionStorage.setItem('namefac2',b )
      let cc  =sessionStorage.getItem('i18n')
      if (cc == 'zh') {
        sessionStorage.setItem('name', '订单详情')
        sessionStorage.setItem('namef', 'Details')

      } else {
        sessionStorage.setItem('name', 'Details')
        sessionStorage.setItem('namef', '订单详情')
      }
    
      this.$router.push({
        path: '/orderDetailsa',
        query: {
          vin: row.vin,
          type: index,
          orderNumber: row.po.id,
        },
      })
    },
    //tab切换
    tabclick (i) {
      // console.log(i);

      // this.action = i
      // this.biao()
    },

    //搜索
    onSubmit () {
      this.biao()
    },

    handleSizeChange (val) {
      this.pageSize = val
      // console.log(`每页 ${val} 条`)
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.biao()
    },
    jstype (e) {
      let c = ''
      let a = this.jsfs
      a.forEach((z) => {
        if (e == z.dictValue && this.inle == 'zh') {
          c = z.dictLabel
        }
        if (e == z.dictValue && this.inle !== 'zh') {
          c = z.dictLabelEn
        }
      })
      return c
    },
    formatStatus (status) {
      if (status == -2) {
        return '拒绝'
      } else if (status == -1) {
        return this.$t('menu.Cancelled')
      } else if (status == 0) {
        return '待支付'
      } else if (status == 1) {
        return this.$t('menu.PendingReview')
      } else if (status == 2) {
        return this.$t('menu.PendingShipment')
      } else if (status == 3) {
        return this.$t('menu.UnderDelivery')
      } else if (status == 4) {
        return this.$t('menu.Completed')
      } else if (status == 5) {
        return this.$t('menu.daizhid')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;


  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
  font-size: 16px;
  font-weight: 600;
}
</style>
